import React, { useState, useEffect, useRef } from "react";
import { getData, postData, serverURL } from "../../../Services/Fetchnodeservices";

// ─────────────────────────────────────────────────────────────────────────────
// ICONS
// ─────────────────────────────────────────────────────────────────────────────
const SearchIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

const PlusIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const EyeIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EditIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

const DeleteIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);

const HideIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

const ShowIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const CloseIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const UploadIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="17 8 12 3 7 8" />
    <line x1="12" y1="3" x2="12" y2="15" />
  </svg>
);

const RefreshIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M23 4v6h-6" />
    <path d="M1 20v-6h6" />
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10" />
    <path d="M20.49 15a9 9 0 0 1-14.85 3.36L1 14" />
  </svg>
);

const SpinnerIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" style={{ animation: "spin 0.8s linear infinite", transformOrigin: "center" }} />
  </svg>
);

// ─────────────────────────────────────────────────────────────────────────────
// ADD SERVICE DIALOG COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
const AddServiceDialog = ({ isDark, onClose, onSave, editingService }) => {
  const [formData, setFormData] = useState({
    title: editingService?.title || "",
    description: editingService?.description || "",
    button_name: editingService?.button_name || "",
    button_link: editingService?.button_link || "",
    status: editingService?.status === "1" || editingService?.status === 1 ? "Active" : "Hidden",
  });
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [dragActive, setDragActive] = useState(false);
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  // Set pic preview when editing
  useEffect(() => {
    if (editingService?.pic) {
      const imgUrl = getImageUrl(editingService.pic);
      setImagePreview(imgUrl);
    }
  }, [editingService]);

  // FIXED: Correct image URL function based on your file path
  const getImageUrl = (picName) => {
    if (!picName || picName.trim() === "" || picName === "NULL" || picName === "null") {
      return null;
    }
    if (picName.startsWith('http')) {
      return picName;
    }
    // For files like "file_6855271635cb59.13563757.webp"
    // The image is stored in public/public/uploadnew/upload/
    // So the URL should be: serverURL/uploadnew/upload/filename
    let filename = picName;
    if (filename.includes('/')) {
      filename = filename.split('/').pop();
    }
    if (filename.includes('\\')) {
      filename = filename.split('\\').pop();
    }
    // Direct path to upload folder
    return `${serverURL}/uploadnew/upload/${filename}`;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (file) => {
    if (file) {
      setImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleFileInput = (e) => {
    const file = e.target.files[0];
    if (file) {
      handleImageChange(file);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);
    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith('image/')) {
      handleImageChange(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.title.trim()) {
      alert("Please enter service title");
      return;
    }
    
    setUploading(true);
    
    // Create FormData for complete submission
    const submitFormData = new FormData();
    submitFormData.append("title", formData.title);
    submitFormData.append("description", formData.description || "");
    submitFormData.append("button_name", formData.button_name || "");
    submitFormData.append("button_link", formData.button_link || "");
    submitFormData.append("status", formData.status === "Active" ? "1" : "0");
    
    if (imageFile) {
      submitFormData.append("pic", imageFile);
    }
    
    if (editingService) {
      submitFormData.append("id", editingService.id);
    }
    
    await onSave(submitFormData, editingService);
    setUploading(false);
  };

  const dialogStyles = {
    overlay: {
      position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.7)", display: "flex", alignItems: "center",
      justifyContent: "center", zIndex: 1000, backdropFilter: "blur(4px)",
    },
    dialog: {
      width: "90%", maxWidth: "560px", background: isDark ? "#141824" : "#ffffff",
      borderRadius: "20px", boxShadow: "0 25px 40px -12px rgba(0,0,0,0.4)",
      overflow: "hidden", animation: "fadeIn 0.2s ease-out",
    },
    header: {
      display: "flex", justifyContent: "space-between", alignItems: "center",
      padding: "18px 24px", borderBottom: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
    },
    title: {
      fontSize: "20px", fontWeight: 700, color: isDark ? "#f1f5f9" : "#0f172a", margin: 0,
    },
    closeBtn: {
      background: "none", border: "none", cursor: "pointer", color: isDark ? "#94a3b8" : "#64748b",
      padding: "4px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "8px",
    },
    body: { padding: "24px", maxHeight: "65vh", overflowY: "auto" },
    formGroup: { marginBottom: "20px" },
    label: {
      display: "block", marginBottom: "8px", fontSize: "13px", fontWeight: 600,
      color: isDark ? "#cbd5e1" : "#334155",
    },
    required: { color: "#ef4444", marginLeft: "4px" },
    input: {
      width: "100%", padding: "12px 14px", background: isDark ? "#0d1117" : "#f8fafc",
      border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", borderRadius: "12px",
      fontSize: "14px", color: isDark ? "#f1f5f9" : "#1e293b", outline: "none",
      transition: "all 0.2s", boxSizing: "border-box",
    },
    textarea: {
      width: "100%", padding: "12px 14px", background: isDark ? "#0d1117" : "#f8fafc",
      border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", borderRadius: "12px",
      fontSize: "14px", color: isDark ? "#f1f5f9" : "#1e293b", outline: "none",
      fontFamily: "inherit", resize: "vertical", minHeight: "100px", boxSizing: "border-box",
    },
    imageUploadArea: {
      border: `2px dashed ${dragActive ? '#3b82f6' : (isDark ? '#1e2740' : '#e2e8f0')}`,
      borderRadius: "16px", padding: "24px", textAlign: "center", cursor: "pointer",
      transition: "all 0.2s", background: isDark ? "rgba(59,130,246,0.05)" : "rgba(59,130,246,0.02)",
      marginTop: "8px",
    },
    imagePreview: { width: "100%", maxHeight: "160px", objectFit: "cover", borderRadius: "12px", marginTop: "16px" },
    uploadIcon: { display: "flex", justifyContent: "center", marginBottom: "12px", color: "#3b82f6" },
    uploadText: { fontSize: "14px", fontWeight: 500, color: isDark ? "#94a3b8" : "#64748b", marginBottom: "6px" },
    uploadHint: { fontSize: "11px", color: isDark ? "#4a5568" : "#94a3b8" },
    radioGroup: { display: "flex", gap: "24px", marginTop: "8px" },
    radioLabel: { display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", fontSize: "14px", color: isDark ? "#f1f5f9" : "#1e293b" },
    radio: { width: "16px", height: "16px", cursor: "pointer" },
    footer: {
      display: "flex", justifyContent: "flex-end", gap: "12px", padding: "16px 24px",
      borderTop: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", background: isDark ? "#0f1520" : "#fafcff",
    },
    cancelBtn: {
      padding: "10px 20px", background: "transparent", border: isDark ? "1px solid #2a3a5a" : "1px solid #cbd5e1",
      borderRadius: "10px", fontSize: "14px", fontWeight: 500, color: isDark ? "#94a3b8" : "#475569", cursor: "pointer",
    },
    saveBtn: {
      padding: "10px 24px", background: uploading ? "#94a3b8" : "#4a6cf7", border: "none",
      borderRadius: "10px", fontSize: "14px", fontWeight: 600, color: "#fff", cursor: uploading ? "not-allowed" : "pointer",
    },
  };

  return (
    <div style={dialogStyles.overlay} onClick={onClose}>
      <div style={dialogStyles.dialog} onClick={(e) => e.stopPropagation()}>
        <div style={dialogStyles.header}>
          <h3 style={dialogStyles.title}>{editingService ? "Edit Service" : "Add Service"}</h3>
          <button style={dialogStyles.closeBtn} onClick={onClose}><CloseIcon /></button>
        </div>
        <form onSubmit={handleSubmit}>
          <div style={dialogStyles.body}>
            <div style={dialogStyles.formGroup}>
              <label style={dialogStyles.label}>Title <span style={dialogStyles.required}>*</span></label>
              <input type="text" name="title" style={dialogStyles.input} placeholder="Enter service title" value={formData.title} onChange={handleChange} required autoFocus />
            </div>

            <div style={dialogStyles.formGroup}>
              <label style={dialogStyles.label}>Description</label>
              <textarea name="description" style={dialogStyles.textarea} placeholder="Enter service description" value={formData.description} onChange={handleChange} />
            </div>

            <div style={dialogStyles.formGroup}>
              <label style={dialogStyles.label}>Image</label>
              <div style={dialogStyles.imageUploadArea} onClick={() => fileInputRef.current?.click()} onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop}>
                <input ref={fileInputRef} type="file" accept="image/png, image/jpeg, image/jpg, image/webp" onChange={handleFileInput} style={{ display: "none" }} />
                <div style={dialogStyles.uploadIcon}><UploadIcon /></div>
                <div style={dialogStyles.uploadText}>{imagePreview ? "Change Image" : "Click or drag image here"}</div>
                <div style={dialogStyles.uploadHint}>PNG, JPG, WebP up to 10MB</div>
                {imagePreview && <img src={imagePreview} alt="Preview" style={dialogStyles.imagePreview} />}
              </div>
            </div>

            <div style={dialogStyles.formGroup}>
              <label style={dialogStyles.label}>Button Name</label>
              <input type="text" name="button_name" style={dialogStyles.input} placeholder="e.g., Join Now, Learn More" value={formData.button_name} onChange={handleChange} />
            </div>

            <div style={dialogStyles.formGroup}>
              <label style={dialogStyles.label}>Button Link</label>
              <input type="text" name="button_link" style={dialogStyles.input} placeholder="e.g., https://example.com or /path" value={formData.button_link} onChange={handleChange} />
            </div>

            <div style={dialogStyles.formGroup}>
              <label style={dialogStyles.label}>Status</label>
              <div style={dialogStyles.radioGroup}>
                <label style={dialogStyles.radioLabel}>
                  <input type="radio" name="status" value="Active" checked={formData.status === "Active"} onChange={handleChange} style={dialogStyles.radio} /> Active
                </label>
                <label style={dialogStyles.radioLabel}>
                  <input type="radio" name="status" value="Hidden" checked={formData.status === "Hidden"} onChange={handleChange} style={dialogStyles.radio} /> Hidden
                </label>
              </div>
            </div>
          </div>
          <div style={dialogStyles.footer}>
            <button type="button" style={dialogStyles.cancelBtn} onClick={onClose}>Cancel</button>
            <button type="submit" style={dialogStyles.saveBtn} disabled={uploading}>
              {uploading ? "Saving..." : (editingService ? "Update Service" : "Save Service")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// SUB-COMPONENTS
// ─────────────────────────────────────────────────────────────────────────────

const StatusBadge = ({ status, isDark }) => {
  const isActive = status === "1" || status === 1;
  const config = isActive 
    ? { bg: isDark ? "rgba(34,197,94,0.15)" : "rgba(34,197,94,0.1)", color: "#22c55e", text: "Active" }
    : { bg: isDark ? "rgba(148,163,184,0.12)" : "rgba(148,163,184,0.08)", color: "#94a3b8", text: "Hidden" };
  return (
    <span style={{ display: "inline-block", padding: "4px 10px", borderRadius: "20px", fontSize: "11px", fontWeight: 600, background: config.bg, color: config.color }}>
      {config.text}
    </span>
  );
};

// FIXED: ImagePlaceholder with correct image path
const ImagePlaceholder = ({ isDark, imageUrl, title }) => {
  const [imgError, setImgError] = useState(false);
  
  const getImageUrl = (picName) => {
    if (!picName || picName.trim() === "" || picName === "NULL" || picName === "null") return null;
    if (picName.startsWith('http')) return picName;
    let filename = picName;
    if (filename.includes('/')) filename = filename.split('/').pop();
    if (filename.includes('\\')) filename = filename.split('\\').pop();
    // Direct path to upload folder
    return `${serverURL}/uploadnew/upload/${filename}`;
  };
  
  const imgUrl = imageUrl && !imgError ? getImageUrl(imageUrl) : null;
  
  return (
    <div style={{
      width: "50px", height: "50px", borderRadius: "8px",
      background: isDark ? "#1e2740" : "#f1f5f9",
      display: "flex", alignItems: "center", justifyContent: "center",
      fontSize: "12px", fontWeight: 500,
      color: isDark ? "#64748b" : "#94a3b8",
      border: isDark ? "1px solid #2a3145" : "1px solid #e2e8f0",
      overflow: "hidden",
    }}>
      {imgUrl ? (
        <img 
          src={imgUrl} 
          alt={title} 
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
          onError={() => setImgError(true)}
        />
      ) : (
        "🖼️"
      )}
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// MAIN COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
const Services = ({ isDark = true }) => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [editingService, setEditingService] = useState(null);
  const itemsPerPage = 10;

  // Fetch services from API
  const fetchServices = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getData("footercertificate/services");
      console.log("Services API Response:", response);

      let servicesData = [];
      if (response && response.status === true && response.data) {
        servicesData = response.data;
      } else if (Array.isArray(response)) {
        servicesData = response;
      } else if (response?.data && Array.isArray(response.data)) {
        servicesData = response.data;
      }

      setServices(servicesData);
    } catch (err) {
      console.error("Error fetching services:", err);
      setError(err.message || "Failed to fetch services");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchServices();
  }, []);

  // Filter services
  const filteredServices = services.filter(service =>
    service.title?.toLowerCase().includes(search.toLowerCase()) ||
    service.description?.toLowerCase().includes(search.toLowerCase())
  );

  // Pagination
  const totalPages = Math.ceil(filteredServices.length / itemsPerPage);
  const paginatedServices = filteredServices.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Toggle status
  const toggleStatus = async (service) => {
    const newStatus = service.status === "1" || service.status === 1 ? "0" : "1";
    try {
      const formData = new FormData();
      formData.append("id", service.id);
      formData.append("status", newStatus);
      
      const response = await postData("footercertificate/update_service", formData, "multipart/form-data");
      if (response && response.status === true) {
        fetchServices();
      } else {
        alert(response?.message || "Failed to update status");
      }
    } catch (error) {
      alert("Failed to update status: " + error.message);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this service?")) {
      try {
        const formData = new FormData();
        formData.append("id", id);
        
        const response = await postData("footercertificate/delete_service", formData, "multipart/form-data");
        if (response && response.status === true) {
          fetchServices();
        } else {
          alert(response?.message || "Failed to delete service");
        }
      } catch (error) {
        alert("Failed to delete service: " + error.message);
      }
    }
  };

  const handleEdit = (service) => {
    setEditingService(service);
    setIsDialogOpen(true);
  };

  const handleView = (service) => {
    alert(`Title: ${service.title}\n\nDescription: ${service.description || "—"}\n\nButton: ${service.button_name || "—"}\nLink: ${service.button_link || "—"}`);
  };

  const handleAddService = () => {
    setEditingService(null);
    setIsDialogOpen(true);
  };

  const handleSaveService = async (formData, existingService) => {
    try {
      let response;
      
      if (existingService) {
        // Update existing service
        response = await postData("footercertificate/update_service", formData, "multipart/form-data");
      } else {
        // Create new service
        response = await postData("footercertificate/create_service", formData, "multipart/form-data");
      }
      
      console.log("Save response:", response);
      
      if (response && response.status === true) {
        fetchServices();
        setIsDialogOpen(false);
        setEditingService(null);
      } else {
        alert(response?.message || "Failed to save service");
      }
    } catch (error) {
      console.error("Save error:", error);
      alert("Failed to save service: " + error.message);
    }
  };

  const styles = {
    container: {
      background: "transparent",
      fontFamily: "'Segoe UI', 'DM Sans', sans-serif",
      padding: "20px 24px",
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "24px",
      flexWrap: "wrap",
      gap: "16px",
    },
    searchWrapper: {
      position: "relative",
      flex: 1,
      maxWidth: "350px",
    },
    searchIcon: {
      position: "absolute",
      left: "12px",
      top: "50%",
      transform: "translateY(-50%)",
      color: "#3b82f6",
    },
    searchInput: {
      width: "100%",
      padding: "10px 12px 10px 38px",
      background: isDark ? "#141824" : "#ffffff",
      border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
      borderRadius: "10px",
      fontSize: "13px",
      color: isDark ? "#f1f5f9" : "#1e293b",
      outline: "none",
    },
    addBtn: {
      display: "flex",
      alignItems: "center",
      gap: "6px",
      padding: "10px 20px",
      background: "#4a6cf7",
      color: "#fff",
      border: "none",
      borderRadius: "10px",
      fontSize: "13px",
      fontWeight: 600,
      cursor: "pointer",
    },
    refreshBtn: {
      display: "flex",
      alignItems: "center",
      gap: "6px",
      padding: "10px 16px",
      background: isDark ? "#1e2740" : "#e2e8f0",
      color: isDark ? "#94a3b8" : "#64748b",
      border: "none",
      borderRadius: "10px",
      fontSize: "13px",
      fontWeight: 500,
      cursor: "pointer",
    },
    tableWrapper: {
      background: isDark ? "#141824" : "#ffffff",
      border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
      borderRadius: "12px",
      overflow: "auto",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      minWidth: "900px",
    },
    th: {
      padding: "14px 16px",
      textAlign: "left",
      fontSize: "12px",
      fontWeight: 700,
      color: "#3b82f6",
      borderBottom: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
      background: isDark ? "#0f1520" : "#f8fafc",
      whiteSpace: "nowrap",
    },
    td: {
      padding: "14px 16px",
      fontSize: "13px",
      color: isDark ? "#e2e8f0" : "#1e293b",
      borderBottom: isDark ? "1px solid #1a2035" : "1px solid #f1f5f9",
    },
    actions: {
      display: "flex",
      gap: "8px",
    },
    actionBtn: {
      background: "none",
      border: "none",
      cursor: "pointer",
      padding: "4px",
      color: isDark ? "#64748b" : "#94a3b8",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    titleCell: {
      fontWeight: 600,
      color: isDark ? "#f1f5f9" : "#1e293b",
    },
    descriptionCell: {
      maxWidth: "350px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      color: isDark ? "#94a3b8" : "#64748b",
    },
    buttonBadge: {
      display: "inline-block",
      padding: "4px 8px",
      borderRadius: "6px",
      fontSize: "11px",
      fontWeight: 500,
      background: isDark ? "rgba(59,130,246,0.15)" : "rgba(59,130,246,0.1)",
      color: "#3b82f6",
    },
    footer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "14px 20px",
      borderTop: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
      background: isDark ? "#0f1520" : "#f8fafc",
    },
    pageInfo: {
      fontSize: "12px",
      color: isDark ? "#64748b" : "#94a3b8",
    },
    pagination: {
      display: "flex",
      gap: "6px",
    },
    pageBtn: (disabled, isActive) => ({
      width: "32px",
      height: "32px",
      borderRadius: "6px",
      border: isActive 
        ? "1px solid #3b82f6" 
        : isDark 
          ? "1px solid #1e2740" 
          : "1px solid #e2e8f0",
      background: isActive 
        ? "#1e3a8a" 
        : isDark 
          ? "#141824" 
          : "#ffffff",
      color: isActive 
        ? "#93c5fd" 
        : disabled 
          ? isDark ? "#2d3a55" : "#cbd5e1"
          : isDark ? "#94a3b8" : "#64748b",
      cursor: disabled ? "not-allowed" : "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }),
    emptyState: {
      padding: "60px",
      textAlign: "center",
      color: isDark ? "#64748b" : "#94a3b8",
      fontSize: "14px",
    },
    loadingState: {
      padding: "60px",
      textAlign: "center",
      color: isDark ? "#64748b" : "#94a3b8",
    },
  };

  return (
    <div style={styles.container}>
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: scale(0.96); }
          to { opacity: 1; transform: scale(1); }
        }
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
      
      {/* Header with Search and Add Button */}
      <div style={styles.header}>
        <div style={styles.searchWrapper}>
          <span style={styles.searchIcon}><SearchIcon /></span>
          <input
            type="text"
            style={styles.searchInput}
            placeholder="Search service..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>
        <div style={{ display: "flex", gap: "10px" }}>
          <button style={styles.refreshBtn} onClick={fetchServices}>
            <RefreshIcon /> Refresh
          </button>
          <button style={styles.addBtn} onClick={handleAddService}>
            <PlusIcon /> Add
          </button>
        </div>
      </div>

      {/* Services Table */}
      <div style={styles.tableWrapper}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>ID</th>
              <th style={styles.th}>Image</th>
              <th style={styles.th}>Title</th>
              <th style={styles.th}>Description</th>
              <th style={styles.th}>Button</th>
              <th style={styles.th}>Status</th>
              <th style={styles.th}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={7} style={styles.loadingState}>
                  <SpinnerIcon /> Loading services...
                </td>              </tr>
            ) : error ? (
              <tr>
                <td colSpan={7} style={styles.loadingState}>
                  <div>Error: {error}</div>
                  <button onClick={fetchServices} style={{ marginTop: "12px", padding: "6px 16px", borderRadius: "8px", border: "none", background: "#3b82f6", color: "#fff", cursor: "pointer" }}>
                    Retry
                  </button>
                </td>
              </tr>
            ) : paginatedServices.length === 0 ? (
              <tr>
                <td colSpan={7} style={styles.emptyState}>
                  No services found
                </td>
              </tr>
            ) : (
              paginatedServices.map((service) => (
                <tr key={service.id}>
                  <td style={styles.td}>{service.id}</td>
                  <td style={styles.td}>
                    <ImagePlaceholder isDark={isDark} imageUrl={service.pic} title={service.title} />
                  </td>
                  <td style={{...styles.td, ...styles.titleCell}}>{service.title}</td>
                  <td style={{...styles.td, ...styles.descriptionCell}} title={service.description}>
                    {service.description}
                  </td>
                  <td style={styles.td}>
                    {service.button_name ? (
                      <div>
                        <span style={styles.buttonBadge}>{service.button_name}</span>
                        {service.button_link && (
                          <div style={{ fontSize: "10px", color: isDark ? "#4a5568" : "#94a3b8", marginTop: "2px" }}>
                            {service.button_link}
                          </div>
                        )}
                      </div>
                    ) : (
                      "—"
                    )}
                  </td>
                  <td style={styles.td}><StatusBadge status={service.status} isDark={isDark} /></td>
                  <td style={styles.td}>
                    <div style={styles.actions}>
                      <button style={styles.actionBtn} onClick={() => handleView(service)} title="View">
                        <EyeIcon />
                      </button>
                      <button style={styles.actionBtn} onClick={() => handleEdit(service)} title="Edit">
                        <EditIcon />
                      </button>
                      <button style={styles.actionBtn} onClick={() => toggleStatus(service)} title={service.status === "1" || service.status === 1 ? "Hide" : "Show"}>
                        {service.status === "1" || service.status === 1 ? <HideIcon /> : <ShowIcon />}
                      </button>
                      <button style={styles.actionBtn} onClick={() => handleDelete(service.id)} title="Delete">
                        <DeleteIcon />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Footer with Pagination */}
      {!loading && filteredServices.length > 0 && (
        <div style={styles.footer}>
          <div style={styles.pageInfo}>
            Showing {Math.min((currentPage - 1) * itemsPerPage + 1, filteredServices.length)} to {Math.min(currentPage * itemsPerPage, filteredServices.length)} of {filteredServices.length} services
          </div>
          <div style={styles.pagination}>
            <button 
              style={styles.pageBtn(currentPage === 1, false)} 
              onClick={() => setCurrentPage(p => Math.max(1, p - 1))} 
              disabled={currentPage === 1}
            >
              ‹
            </button>
            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
              let pageNum;
              if (totalPages <= 5) pageNum = i + 1;
              else if (currentPage <= 3) pageNum = i + 1;
              else if (currentPage >= totalPages - 2) pageNum = totalPages - 4 + i;
              else pageNum = currentPage - 2 + i;
              return pageNum <= totalPages && (
                <button 
                  key={pageNum} 
                  style={styles.pageBtn(false, currentPage === pageNum)} 
                  onClick={() => setCurrentPage(pageNum)}
                >
                  {pageNum}
                </button>
              );
            })}
            <button 
              style={styles.pageBtn(currentPage === totalPages, false)} 
              onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} 
              disabled={currentPage === totalPages}
            >
              ›
            </button>
          </div>
        </div>
      )}

      {/* Add/Edit Service Dialog */}
      {isDialogOpen && (
        <AddServiceDialog
          isDark={isDark}
          onClose={() => {
            setIsDialogOpen(false);
            setEditingService(null);
          }}
          onSave={handleSaveService}
          editingService={editingService}
        />
      )}
    </div>
  );
};

export default Services;